module.exports = __webpack_public_path__ + "img/logo_agap_72dpi.42f5decf.png";